export enum PaymentGateway {
  NONE = '',
  TRIAL = 'trial',
  PAYPAL = 'paypal',
  STRIPE = 'stripe'
}
